<template>
  <div class="home">
    <div class="landingBackground">
      <Landing />
    </div>
    <Steps />
    <hr>
    <div id="triggerPractices"></div>
    <Practices />
    <hr>
    <div id="triggerCapacity0"></div>
    <div id="triggerCapacity1"></div>
    <Learning />
    <hr>
    <Projects />
    <div id="triggerStory0"></div>
    <div class="storiesbg">
      <Stories />
    </div>
    <Brands />
    <div id="triggerOffice0"></div>
    <hr>
    <Offices />
    <iframe :src="myJson.offices.offices[$store.state.showCity].iframe" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="t"></iframe>
    <Footer />
    <FooterSmall />
    <scrollBack />
  </div>
</template>

<script>
// @ is an alias to /src
import Landing from "@/components/home/Landing.vue";
import Steps from "@/components/home/Steps.vue"
import Practices from "@/components/home/Practices.vue"
import Learning from "@/components/home/Learning.vue"
import Projects from "@/components/home/Projects.vue"
import Stories from "@/components/home/Stories.vue"
import Brands from "@/components/home/Brands.vue"
import Offices from "@/components/home/Offices.vue"
import Footer from "@/components/Footer.vue"
import FooterSmall from "@/components/FooterSmall.vue"
import scrollBack from "@/components/scrollBack.vue"
import json from '@/locales/en.json'

export default {
  name: "home",
  components: {
    Landing,
    Steps,
    Practices,
    Learning,
    Projects,
    Stories,
    Brands,
    Offices,
    Footer,
    FooterSmall,
    scrollBack
  },
  data: function() {
    return {
      myJson: json
    }
  }
};
</script>

<style lang="scss">
.landingBackground {
  background: url('../assets/bg_Dots.png') 100%;
}
</style>